import { configureStore } from '@reduxjs/toolkit';
import languageReducer from '../redux/languageReducer';
export default configureStore({
  reducer: {
    language: languageReducer,
  },
});
